<template>
    <modal name="responsabilidad">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <h2 class="title_section">Responsabilidad de los datos</h2>
                </div>
                <div class="col-md-12 col-sm-12 text_responsabilidad">
                    <p class="noselect">{{ text }}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12 text-center">
                    <a @click="hideModal()" class="btn btn-info btn-aceptar">Aceptar</a>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import axios from "axios";
import config from '../../helpers/config';

    export default {
        data() {
            return {
                text: ''
            }
        },

        created() {
            const that = this
            axios
                .get(
                    `${config.urlApi}/privacies?filter[where][typeDif]=2&filter[limit]=1`,
                    {}
                )
                .then(response => {
                    that.text = response.data[0].text;

                })
                .catch(function (error) {
                    //console.log(error)
                });
        },
        methods: {
        hideModal(){
            //console.log("ohoh")
            this.$modal.hide('responsabilidad');
        }}
    };
</script>


<style>
    .container > .row {
        margin-top: 30px;
        margin-left: 10px;
        margin-bottom: 30px;
    }

    .title_section {
        color: #3366cc;
        font-weight: bolder;
    }

    .text_responsabilidad {
        color: #000;
    }

    .v--modal-box {
        width: 60% !important;
        margin: auto !important;
        left: 0px !important;
        height: 100% !important;
        top: 60px !important;
    }

    .btn-aceptar {
        width: 250px;
        background: #3366cc !important;
        color: #fff !important;
    }

    .btn-aceptar:hover {
        cursor: pointer;
    }

    @media (max-width: 768px) {
        .v--modal-box.v--modal {
            width: 90% !important;
            margin: auto;
            top: 5px !important;
        }
    }
    .noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>


